export { default as MarketingCarousel } from './marketing-carousel'
